import { render, staticRenderFns } from "./MarkAsLostAsset.vue?vue&type=template&id=9b3d6342"
import script from "./MarkAsLostAsset.vue?vue&type=script&lang=js"
export * from "./MarkAsLostAsset.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports